import React from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'react-bootstrap';
import { IconButton } from '@sumologic/yama-ds-components';

import Icon from '~/components/Icon/Icon';
import Translate from '~/components/Translate/Translate';

const HeaderModal = props => {
    const {
        icon,
        title,
        description,
        onHide,
        disableCloseModalButton = false
    } = props;
    const format = (value, classes) => {
        if (value) {
            return 'string' !== typeof value
                ? value // 𝘦𝘹𝘱𝘦𝘤𝘵𝘦𝘥 𝘵𝘳𝘢𝘯𝘴𝘭𝘢𝘵𝘦𝘥 𝘦𝘭𝘦𝘮𝘦𝘯𝘵
                : value?.length > 0 && (
                      <span className={classes}>
                          <Translate message={value} />
                      </span>
                  );
        }
    };
    return (
        <Modal.Header data-testid="header-modal">
            <Modal.Title as="h5">
                <span>
                    {icon?.length && <Icon type={`${icon} pe-2`} />}
                    {format(title, 'pe-3')}
                </span>
                &ensp;
                {format(description, 'description')}
            </Modal.Title>
            {onHide && (
                <IconButton
                    data-testid="close-modal-button"
                    onClick={onHide}
                    disabled={disableCloseModalButton}
                    size="small"
                >
                    <Icon type="cross2" size="sm"/>
                </IconButton>
            )}
        </Modal.Header>
    );
};

HeaderModal.propTypes = {
    title: PropTypes.oneOfType([PropTypes.string, PropTypes.element])
        .isRequired,
    description: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
    onHide: PropTypes.func,
    icon: PropTypes.string,
    disableCloseModalButton: PropTypes.bool
};

// HeaderModal.defaultProps = {};

export default HeaderModal;
